<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <v-layout row wrap ma-0>
          <v-flex xs6>
            <v-layout justify-center align-center text-xs-center>
              <v-flex>
                <v-icon v-if="type == 'icon'" size="56px" :color="color">
                  {{ icon }}
                </v-icon>
                <img
                  v-else-if="type == 'antmedia'"
                  src="@/assets/images/antmedia.png"
                  width="56"
                />
                <img
                  v-else-if="type == 'fbase'"
                  src="@/assets/images/isotipo.png"
                  width="56"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6 py-3 class="text-xs-center white--text" :class="color">
            <div class="headline">
              {{ title | capitalize }}
            </div>
            <span class="caption">{{ subTitle }}</span>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    icon: String,
    type: {
      type: String,
      default: 'icon',
    },
    title: {
      type: [String, Number],
      default: '-',
    },
    subTitle: String,
    color: String,
  },
}
</script>
